import React from 'react';
import dayjs from 'dayjs';
import classes from './ExpenseMobileCard.module.scss';

export default function ExpenseMobileCard(props) {
  const { info } = props;

  return (
    <div className={classes.container}>
      <div className={classes.column}>
        <p className={classes.comment}>{info.ClaimDescription}</p>
        <p className={classes.date}>{dayjs(info.CreatedDate).format('D MMM YYYY')}</p>
      </div>
      <div className={classes.column}>
        <p className={classes.amount}>
          {info.ExpenseCurrency?.Symbol} {info.TotalExpense}
        </p>
      </div>
    </div>
  );
}
